"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_AMOUNT_VALUE = 'SET_AMOUNT_VALUE';
exports.RESET_AMOUNT_VALUE = 'RESET_AMOUNT_VALUE';



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/amount/types.ts
// module id = 372
// module chunks = 5